// extracted by mini-css-extract-plugin
export default {"container":"Hl0amCIsMyXLhTe7JEIO","label":"deTbjxZHVM8E0N_Q1Ia5","text":"Ndr0GZRMsOwZtpDsD8x5","button":"euYBN9DrZFBEexVwNFKg"};